export var EColumnType;
(function (EColumnType) {
    EColumnType["Double"] = "DOUBLE";
    EColumnType["String"] = "STRING";
    EColumnType["Boolean"] = "BOOLEAN";
    EColumnType["Int"] = "INT";
    EColumnType["Long"] = "LONG";
    EColumnType["Bigint"] = "BIGINT";
    EColumnType["Date"] = "DATE";
    EColumnType["ListDouble"] = "LIST_DOUBLE";
    EColumnType["Tenor"] = "TENOR";
})(EColumnType || (EColumnType = {}));
